import { MatterType } from '@/database/baseTypes';

export const colorsForMatterType = (
  matterType: MatterType,
): { background: string; foreground: string } => {
  // Isolating these colors from the color palette - it's more important that
  // we differentiate the matter types here. Conformance to the color palette
  // is not a priority.
  switch (matterType) {
    case 'ARAG':
      return { background: '#007bff', foreground: '#ffffff' };
    case 'MetLife':
      return { background: '#04cc00', foreground: '#ffffff' };
    case 'LegalEase':
      return { background: '#ff00ff', foreground: '#ffffff' };
    case 'OtherInsurance':
      return { background: '#7b7b7b', foreground: '#ffffff' };
    case 'FlatFee':
      return { background: '#7c2eb8', foreground: '#ffffff' };
    case 'Hourly':
      return { background: '#ff8000', foreground: '#ffffff' };
    case 'Contingency':
      return { background: '#e3f113', foreground: '#000000' };
    case `Don't Know`:
      return { background: '#7b7b7b', foreground: '#ffffff' };
    case 'Pro Bono':
      return { background: '#007bff', foreground: '#ffffff' };
    case 'Subscription':
      return { background: '#007bff', foreground: '#ffffff' };
  }
};
